import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { HotelCategory } from '../../../../../../components/HotelCategory/index.js';
import { Container } from '../../../../../../components/UpliftAds/components/Banner/components/Recommender/components/Container.js';
import { Content } from '../../../../../../components/UpliftAds/components/Banner/components/Recommender/components/Content.js';
import { Image } from '../../../../../../components/UpliftAds/components/Banner/components/Recommender/components/Image.js';
import { LabelMedium, LabelMediumBold, LabelXLargeBold, LabelXSmall, Stack } from '../../../../../../primitives/index.js';
import { priceFormatter } from '../../../../../../utils/index.js';
export const Recommender = ({
  title,
  subtitle,
  image,
  price
}) => {
  const {
    t
  } = useTranslation('upliftAds');
  return _jsxs(Stack, {
    spacing: "small",
    children: [_jsx(LabelMedium, {
      color: "contentSecondary",
      children: t('label')
    }), _jsxs(Container, {
      spacing: "none",
      children: [_jsx(Image, {
        src: image,
        alt: ""
      }), _jsxs(Content, {
        direction: "column",
        spacing: "medium",
        children: [_jsxs(Stack, {
          spacing: "xSmall",
          children: [_jsx(HotelCategory, {
            value: 4.5,
            type: "verified"
          }), _jsx(LabelMediumBold, {
            children: title
          }), _jsx(LabelMedium, {
            truncate: 1,
            color: "contentSecondary",
            children: subtitle
          })]
        }), _jsxs(Stack, {
          direction: "row",
          justifyContent: "end",
          alignItems: "end",
          spacing: "xSmall",
          children: [_jsx(LabelXSmall, {
            children: t('price.prefix')
          }), price && _jsx(LabelXLargeBold, {
            textAlign: "right",
            children: priceFormatter(t('price.locale'), t('price.currency')).format(Number(price))
          }), _jsx(LabelXSmall, {
            children: t('price.suffix')
          })]
        })]
      })]
    })]
  });
};